// extracted by mini-css-extract-plugin
export default {"template":"DonatersTopListLabelProperty_template__frND3"};